/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import {FONTS} from "@res/fonts";
import {COLORS} from "@res/colors";

type Props = {
    text: string
    textStyle?: CSSProperties
    onClick: () => void
    enabled?: boolean
}

export class OutlineButton
    extends React.Component<Props> {

    static defaultProps = {
        enabled: true
    };

    render() {
        const textStyle = {
            padding: '5px 15px',
            ...this.props.textStyle
        };
        if (!this.props.enabled)
            textStyle.color = "rgb(160 164 169)";

        return <div className={'flex_center'}
                    onClick={() => this.props.enabled && this.props.onClick()}
                    style={{
                        cursor: this.props.enabled ? "pointer" : "default",
                        minHeight: 40,
                        minWidth: 120,
                        borderRadius: 4,
                        textAlign: "center",
                        border: `1px solid ${this.props.enabled ? COLORS.neutral_text_dark_2 : "#d5dce4"}`
                    }}>
            {FONTS.medium_16_secondary_dark(this.props.text, textStyle)}
        </div>;
    }

}
